module.exports = __webpack_public_path__ + "static/media/DIN-BoldAlternate.ff6e55b4.woff";